(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementTicker extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.announcement-ticker__track');
      const original = track ? track.querySelector('.announcement-ticker__group') : null;

      if (track && original && !track.dataset.cloned) {
        const clone = original.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
        track.dataset.cloned = 'true';
      }
    }
  }

  if (!customElements.get('announcement-ticker')) {
    customElements.define('announcement-ticker', AnnouncementTicker);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
